import { useTranslation } from 'react-i18next';
import { useModal } from '../../contexts';
import Modal from '../Modal';

function OnboardingConfirmSkipModal({ onConfirm }: { onConfirm: () => void }) {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  return (
    <Modal
      size="sm"
      title={t('Are you sure you want to skip the onboarding process?')}
      subtitle={t('You can continue the onboarding process at a later date from the profile section of settings.')}
      primaryButtonProps={{
        text: t('Skip'),
        onClick: () => {
          closeModal();
          onConfirm();
        },
      }}
      secondaryButtonProps={{
        text: t('Cancel'),
        onClick: closeModal,
      }}
    />
  );
}

export default OnboardingConfirmSkipModal;
